import mitt from 'mitt';
export const emitter = mitt();

export const saveDataToStorage = (userId, name) => {
  const data = { userId, name };
  sessionStorage.setItem('storedData', JSON.stringify(data));
};

export const getDataFromStorage = () => {
  const data = sessionStorage.getItem('storedData');
  return data ? JSON.parse(data) : { userId: '', name: '' };
};